import { render, staticRenderFns } from "./TrendingCharts.vue?vue&type=template&id=3d46349b&scoped=true&"
import script from "./TrendingCharts.vue?vue&type=script&lang=js&"
export * from "./TrendingCharts.vue?vue&type=script&lang=js&"
import style0 from "./TrendingCharts.vue?vue&type=style&index=0&id=3d46349b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d46349b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d46349b')) {
      api.createRecord('3d46349b', component.options)
    } else {
      api.reload('3d46349b', component.options)
    }
    module.hot.accept("./TrendingCharts.vue?vue&type=template&id=3d46349b&scoped=true&", function () {
      api.rerender('3d46349b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/TrendingCharts.vue"
export default component.exports